import * as z from "zod";

export const hasReachedConversationThreshold = {
  name: "hasReachedConversationThreshold" as const,
  input: z.void(),
  output: z.object({ hasReachedThreshold: z.boolean() }),
};
